import React, { useState, useEffect } from 'react'
import { Avatar } from '@material-ui/core'

export const stringToColor = string => {
  if (!string) return 'hsl(0, 0%, 50%)'
  let hash = 0
  for (let i = 0; i < string.length; i++) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash)
  }
  const h = Math.abs(hash) % 360
  return `hsl(${h}, 70%, 45%)`
}

export const getInitials = name => {
  if (!name) return ''
  const names = name.trim().split(' ')
  if (names.length === 1) return names[0].charAt(0).toUpperCase()
  return (names[0].charAt(0) + names[names.length - 1].charAt(0)).toUpperCase()
}

const UserAvatar = ({
  name,
  src,
  className,
  style,
  onClick,
  isGroup = false
}) => {
  const [imgError, setImgError] = useState(false)

  useEffect(() => {
    setImgError(false)
  }, [src])

  const displayName = name || ''

  const hasValidPhoto = !isGroup && Boolean(src) && !imgError

  const dynamicStyle = !hasValidPhoto
    ? {
        backgroundColor: stringToColor(displayName),
        color: '#ffffff',
        fontWeight: 'bold',
        fontSize: '1rem',
        ...style
      }
    : { ...style }

  return (
    <Avatar
      className={className}
      style={dynamicStyle}
      onClick={onClick}
      src={hasValidPhoto ? src : undefined}
      imgProps={{
        onError: () => setImgError(true)
      }}
    >
      {!hasValidPhoto ? getInitials(displayName) : null}
    </Avatar>
  )
}

export default UserAvatar
